import React, { useCallback } from 'react';
import { isUndefined } from 'lodash/fp';
import classnames from 'classnames';

import styles from './Table.module.scss';
import { ArkRow, ArkTableComponents } from './types';
import { TooltipCell } from './TooltipCell';
import { ColourCell } from './ColourCell';
import { RiskFieldValueCell } from './RiskFieldValueCell';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const TableCell: React.FC<{
    row: ArkRow
    parentField: string;
    field: string;
    secondaryComponent?: keyof ArkTableComponents;
    valueFormatter?: (value: any, row: any, index: number) => string | string[] | boolean | null;
}> = ({ row, parentField, field, secondaryComponent, valueFormatter }) => {

    const getCellValues = useCallback((row: ArkRow, field: string): any[] => (row[parentField] as any[]).map(parentField => parentField[field]), [parentField]);

    const values = getCellValues(row, field);

    const getCell = useCallback((value: any, component: keyof ArkTableComponents | undefined, index: number) => {
        const valueFormatted = !isUndefined(valueFormatter) && valueFormatter(value, row, index) || null;
        if (isUndefined(component)) {
            return <div className={styles.tableTextCell}>{valueFormatted || value}</div>;
        }

        switch (component) {
            case 'tooltip':
                return <TooltipCell value={value} valueFormatted={valueFormatted as string} />;
            case 'colour':
                return <ColourCell value={value} valueFormatted={valueFormatted as string[]} />;
            case 'riskFieldValue':
                return <RiskFieldValueCell value={value} valueFormatted={valueFormatted as string} />;
            default:
                return <div className={styles.tableTextCell}>UNKNOWN</div>;
        }
    }, [row, valueFormatter]);

    return (
        <div className={styles.tableCellWrapper}>
            {values.map((value, index) => (
                <div className={classnames(styles.tableCellRowWrapper, { [styles.tableCellRowBorder]: index !== values.length - 1 })} style={{ height: `${values.length === 1 ? 100 : 90}%` }} key={index} >{getCell(value, secondaryComponent, index)}</div>
            ))}
        </div>
    );
};
